import { render, staticRenderFns } from "./gate_pass.vue?vue&type=template&id=5664a866&scoped=true"
import script from "./gate_pass.vue?vue&type=script&lang=js"
export * from "./gate_pass.vue?vue&type=script&lang=js"
import style0 from "./gate_pass.vue?vue&type=style&index=0&id=5664a866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5664a866",
  null
  
)

export default component.exports